// origin services comes from https://dashboard.tawk.to/#/admin/5fa571f78e1c140c2abb77ab/chat-widget
// documentation  https://developer.tawk.to/javascript-api/?lang=es
import { useEffect } from 'react'

function TawkTo({ email, fullName }) {
	useEffect(() => {
		if (!window) {
			throw new Error('DOM is unavailable')
		}
		window.Tawk_API = window.Tawk_API || {}
		window.Tawk_LoadStart = new Date()

		// pasando los atributos a tawk.to al cargar el widget
		window.Tawk_API.onLoad = () => {
			window.Tawk_API.setAttributes({
				fullName,
				email
			})
		}

		const tawk = document.getElementById('tawkId')
		if (tawk) {
			// Prevenir que TawkTo cree un script raíz si ya existe
			return window.Tawk_API
		}

		const script = document.createElement('script')
		script.id = 'tawkId'
		script.defer = true
		script.src = 'https://embed.tawk.to/5fa571f78e1c140c2abb77ab/1emf9vtcm'
		script.charset = 'UTF-8'
		script.setAttribute('crossorigin', '*')

		const firstScriptTag = document.getElementsByTagName('script')[0]
		if (!firstScriptTag || !firstScriptTag.parentNode) {
			throw new Error('DOM is unavailable')
		}

		firstScriptTag.parentNode.insertBefore(script, firstScriptTag)
	}, [email, fullName])

	return null
}

export default TawkTo

// real script
// <!--Start of Tawk.to Script-->
// <script type="text/javascript">
// var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
// (function(){
// var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
// s1.async=true;
// s1.src='https://embed.tawk.to/5fa571f78e1c140c2abb77ab/1emf9vtcm';
// s1.charset='UTF-8';
// s1.setAttribute('crossorigin','*');
// s0.parentNode.insertBefore(s1,s0);
// })();
// </script>
// <!--End of Tawk.to Script-->
